import { z } from 'zod';

export const SearchCriteriaSchema = z.object({
  role: z.string().min(1).max(200),
  skills: z.array(z.string().min(1).max(50)).min(1).max(20),
  location: z.string().max(100).optional(),
  experienceYears: z.number().int().min(0).max(50).optional(),
  remote: z.boolean().optional(),
  languages: z.array(z.string()).max(10).optional(),
  salaryMin: z.number().int().min(0).optional(),
  salaryMax: z.number().int().min(0).optional(),
  additionalNotes: z.string().max(500).optional(),
  include: z.string().max(300).optional(),
  exclude: z.string().max(300).optional(),
});

export const CreateSearchSchema = z.object({
  title: z.string().min(1).max(200),
  criteria: SearchCriteriaSchema,
});

/** Phase 7: recruiter behaviour signal (re-ranking fuel). No candidate PII. */
export const SignalSchema = z.object({
  jobId: z.string().max(200).optional(),
  roleFamily: z.string().max(40).optional(),
  source: z.string().min(1).max(40),
  url: z.string().url(),
  signal: z.enum(['opened', 'imported', 'skipped', 'contacted', 'hired']),
  rankShown: z.number().int().min(0).max(1000).optional(),
  wasExploration: z.boolean().optional(),
});

export const SendMessageSchema = z.object({
  content: z.string().min(1).max(2000),
});

export const UpdateFavoriteSchema = z.object({
  status: z.enum(['pending', 'reviewed', 'contacted', 'declined']).optional(),
  notes: z.string().max(2000).optional(),
});

/**
 * Candidate opt-in submission. The candidate submits their OWN public profile
 * with explicit consent — lawful basis = consent. `consent` MUST be true.
 */
export const CandidateOptInSchema = z.object({
  name: z.string().min(2).max(120),
  profileUrl: z.string().url().max(500).optional(),
  headline: z.string().max(200).optional(),
  location: z.string().max(100).optional(),
  skills: z.array(z.string().min(1).max(50)).min(1).max(30),
  summary: z.string().max(2000).optional(),
  email: z.string().email().max(200).optional(),
  available: z.string().max(50).optional(),
  consent: z.literal(true),
});

export type CreateSearchInput = z.infer<typeof CreateSearchSchema>;
export type SendMessageInput = z.infer<typeof SendMessageSchema>;
export type UpdateFavoriteInput = z.infer<typeof UpdateFavoriteSchema>;
export type SearchCriteriaInput = z.infer<typeof SearchCriteriaSchema>;
export type CandidateOptInInput = z.infer<typeof CandidateOptInSchema>;
